const SCOPE = 'lint-panel';

export const LintPanelTestIds = {
  ROOT: `${SCOPE}.root`,
};
